module.exports = __webpack_public_path__ + "static/media/  (135).480497b6.jpg";